import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { Role } from '../models/role';

@Injectable()

export class DocumentLoadService {
  constructor(
    private afs: AngularFirestore,
    public afAuth: AngularFireAuth
  ) {}

  public loadDocument(sheetDoc, docid): Promise<any> {
    return new Promise((resolve, reject) => {
      this.fetchDocument(sheetDoc.ref).then(doc_snap => {
        this.checkPermissions(doc_snap, docid).then((role: Role) => {
          resolve(role);
        }).catch(e => {
          reject(e);
        });
      }).catch(() => {
        reject("not_found_error");
      });
    });
  }

  private checkPermissions(doc_snap, docid) {
    return new Promise((resolve, reject) => {
      this.afAuth.authState.subscribe(u => {
        if (u.uid === doc_snap.get('owner_id')) {
          resolve({ read: true, write: true, owner: true } as Role);
        } else {
          this.fetchPermission(u.uid, docid).then(role => {
            resolve(role);
          }).catch(e => {
            reject('permission_error');
          });
        }
      });
    });
  }

  private fetchDocument(doc_ref) {
    return new Promise((resolve, reject) => {
      doc_ref.get().then(doc_snap => {
        doc_snap.exists ? resolve(doc_snap) : reject();
      });
    });
  }

  private fetchPermission(uid, docid) {
    return new Promise((resolve, reject) => {
      // Observable .take(1) .first() is another option instead of using .ref
      this.afs.collection('permissions').ref.where('uid', '==', uid).where('docid', '==', docid).get().then(query_snap => {
        if (query_snap.empty) {
          reject('permission_error');
        } else {
          query_snap.docs[0].ref.get().then(doc_snap => {
            resolve({ read: doc_snap.get('read'), write: doc_snap.get('write'), owner: false } as Role);
          });
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// /Users/traev/Sites/btt/src/app/services/document-load.service.ts